import './HeaderNavLink.scss';

import cn from 'classnames';
import React from 'react';
import { Trans } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';

import {
  HeaderNavLinkPropTypes,
  NavLinkDefaultProps,
} from './HeaderNavLink.proptypes';

const HeaderNavLink = ({
  Icon,
  className,
  context,
  disabled,
  label,
  to,
  variant,
}) => {
  const { pathname } = useLocation();
  const isActive = pathname.startsWith(to);

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <NavLink
      className={cn(className, 'nav-link', `nav-link--${variant}`, {
        'nav-link--active': isActive,
        'nav-link--disabled': disabled,
      })}
      to={to}
      onClick={handleClick}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...(context ? { 'data-qa-id': context } : null)}
    >
      <span className="inner-container nav-link__container">
        {Icon && (
          <span className={cn('nav-link__icon', `nav-link__icon--${variant}`)}>
            {Icon}
          </span>
        )}
        <span className={cn('nav-link__label', `nav-link__label--${variant}`)}>
          <Trans allowHTML components={{ span: <span /> }} i18nKey={label} />
        </span>
      </span>
    </NavLink>
  );
};

HeaderNavLink.defaultProps = {
  ...NavLinkDefaultProps,
};

HeaderNavLink.propTypes = {
  ...HeaderNavLinkPropTypes,
};

export default HeaderNavLink;
